/** @file dock-manager/NowIndicator.jsx — red vertical line at "now". */

export default function NowIndicator({ start, end, left, pxPerHour }) {
  const now = new Date();
  if (now < start || now > end) return null;
  const offsetHours = (now - start) / 3600 / 1000;
  return (
    <div
      className="absolute top-0 bottom-0 w-px bg-red-500 z-20 pointer-events-none"
      style={{ left: left + offsetHours * pxPerHour }}
      data-testid="now-indicator"
    >
      <div className="absolute -top-2 -left-1.5 h-3 w-3 rounded-full bg-red-500 ring-2 ring-white" />
    </div>
  );
}

